import { render } from "./Tooltip.vue?vue&type=template&id=90edb2c8&scoped=true"
const script = {}

import "./Tooltip.vue?vue&type=style&index=0&id=90edb2c8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90edb2c8"]])

export default __exports__